import script from "./QuickAddSelectField.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAddSelectField.vue?vue&type=script&setup=true&lang=js"

import "./QuickAddSelectField.vue?vue&type=style&index=0&id=0c5d5865&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5d5865"]])

export default __exports__